import request from "@/utils/request";

// 列表(主数据列表)
export function loadAppActivityPlaceListDataApi(data) {
  return request({
    url: "web/appActivityPlace/listData",
    method: "post",
    data
  });
}
// 导出
export function loadAppActivityPlaceExportDataApi(data) {
  return request({
    url: "web/appActivityPlace/exportData",
    method: "post",
    data
  });
}

// 操作
export function saveOrUpdateAppActivityPlaceApi(data) {
  return request({
    url: "web/appActivityPlace/saveOrUpdate",
    method: "post",
    data
  });
}

// 查看
export function initAppActivityPlaceApi(data) {
  return request({
    url: "web/appActivityPlace/init",
    method: "post",
    data
  });
}

// 下拉列表
export function getAppActivityPlaceListApi(data) {
  return request({
      url: "web/appActivityPlace/listSelectData",
      method: "post",
      data
  });
}